import { CommonModule, HashLocationStrategy, LocationStrategy  } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ButtonNavModule } from './shared/components/button-nav/button-nav.component';
import { HeaderModule } from './shared/components/header/header.component';
import { HelpResourcesComponent } from './pages/help-resources/help-resources.component';
import { HelpModule } from './shared/components/help/help.component';
import {ConfirmationComponent} from './pages/confirmation/confirmation.component';

// const routes: Routes=[];
const routes: Routes = [
  {
    path: '',
    redirectTo: 'ui/home',
    pathMatch: 'full',
  },
  {
    path: 'ui',
    redirectTo: 'ui/home',
    pathMatch: 'full',
  },
  {
    path: 'ui/home',
    component: HomeComponent,
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'help-resources',
    component: HelpResourcesComponent,
  },
  {
    path: 'confirmation',
    component: ConfirmationComponent,
  },
  {
    path: '**',
    redirectTo: 'ui/home',
  },
];

const routingConfig = {
  enableTracing: false, // <-- debugging purposes only
  useHash: false 
};

@NgModule({
  imports: [
    RouterModule.forRoot(routes,  { useHash: false  }),
    CommonModule,
    ButtonNavModule,
    HeaderModule,
    HelpModule
  ],
  exports: [RouterModule],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
  declarations: [HomeComponent, HelpResourcesComponent],
})
export class AppRoutingModule {}
